import React, { useState, useEffect } from "react";
import ButtonLeft from "../assets/images/icons/Button_left.svg";
import ButtonRight from "../assets/images/icons/Button_right.svg";
import { Box } from "@mui/material";

const TestCarousel = ({ data, base, action, eyes, sex, outfit, type: propsType }) => {
  const [icons, setIcons] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMale, setSex] = useState(true);
  const [type, setType] = useState("");
  const [loadedIcons, setLoadedIcons] = useState({});

  const [selectedIcon, setSelectedIcon] = useState(null);
  const onChange = (event) => {
    action(type, event);
    setSelectedIcon(event);
  };

  useEffect(() => {
    setType(propsType);
    setSex(sex);
    setIcons(data);
    if (base) {
      setSelectedIcon(base.replace(/male\/|female\//, "") || data[0].name);
    } else if (eyes) {
      setSelectedIcon(eyes.replace(/male\/|female\//, "") || data[0].name);
    } else if (outfit) {
      setSelectedIcon(outfit.replace(/male\/|female\//, "") || data[0].name);
    }
  }, [data, currentIndex]);

  const handlePrev = () => {
    setCurrentIndex(currentIndex === 0 ? icons.length - 1 : currentIndex - 1);
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex === icons.length - 1 ? 0 : currentIndex + 1);
  };

  const handleIconLoad = (iconId) => {
    setLoadedIcons((prevState) => ({ ...prevState, [iconId]: true }));
  };

  return (
    <Box>
      <Box className="carousel__controls">
        <button onClick={handlePrev}>
          <img src={ButtonLeft} alt="" />
        </button>
        <button onClick={handleNext}>
          <img src={ButtonRight} alt="" />
        </button>
      </Box>
      <Box className="carousel">
        {icons.map((icon, index) => (
          <Box key={icon.id} className={`carousel__icon-container ${index >= currentIndex && index < currentIndex + 3 ? "" : "hide"}`}>
            {!loadedIcons[icon.id] && <Box className="placeholder-container"></Box>}
            <img
              src={`https://storage.googleapis.com/anekdamian-site/preview/${type}/${isMale}/${icon.name}`}
              onClick={() => {
                onChange(icon.name);
              }}
              className={`character-component ${loadedIcons[icon.id] ? "" : "hidden"}`}
              alt={icon.name}
              onLoad={() => handleIconLoad(icon.id)}
              style={{ border: icon.name === selectedIcon ? "2px solid #91ab87" : "none", cursor: 'pointer', transition: "0.1s ease-in-out" }} // Применяем бордер к img
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TestCarousel;
